export default __webpack_public_path__ + "static/media/screenshot_app_pathways_purple.65d0942e.png";